import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "px-6 py-2"
};
const _hoisted_2 = {
  name: "form"
};
const _hoisted_3 = {
  key: 0,
  class: "text-left text-uppercase;"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  class: "text-left"
};
const _hoisted_7 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_main_header = _resolveComponent("main-header");
  const _component_v_table = _resolveComponent("v-table");
  const _component_LlSecondaryButton = _resolveComponent("LlSecondaryButton");
  const _component_expense_template_modal = _resolveComponent("expense-template-modal");
  const _component_v_dialog = _resolveComponent("v-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [$data.me ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_main_header, {
    content: "Expense Templates"
  }), _createElementVNode("form", _hoisted_2, [_withDirectives(_createVNode(_component_v_table, {
    density: "compact"
  }, {
    default: _withCtx(() => [_createElementVNode("thead", null, [_createElementVNode("tr", null, [_cache[5] || (_cache[5] = _createElementVNode("th", {
      class: "text-left text-uppercase;"
    }, "Label", -1)), _cache[6] || (_cache[6] = _createElementVNode("th", {
      class: "text-left text-uppercase;"
    }, "Amount", -1)), $data.ledes ? (_openBlock(), _createElementBlock("th", _hoisted_3, "Code")) : _createCommentVNode("", true), _cache[7] || (_cache[7] = _createElementVNode("th", {
      class: "text-left text-uppercase;"
    }, "Product/Service", -1)), _cache[8] || (_cache[8] = _createElementVNode("th", {
      class: "text-left text-uppercase;"
    }, "Description", -1))])]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.form.expenses, (rate, idx) => {
      return _openBlock(), _createElementBlock("tr", {
        key: idx,
        onClick: $event => $options.updateExpenseTemplate(rate, idx),
        class: "table-row"
      }, [rate.saved ? (_openBlock(), _createElementBlock("td", _hoisted_5, _toDisplayString(rate.label), 1)) : _createCommentVNode("", true), _createElementVNode("td", null, _toDisplayString(rate.amount), 1), _withDirectives(_createElementVNode("td", {
        style: {
          "width": "300px"
        }
      }, _toDisplayString(rate.code?.label), 513), [[_vShow, $data.ledes]]), _createElementVNode("td", _hoisted_6, _toDisplayString(rate.accounting?.service?.name), 1), _createElementVNode("td", null, [rate.saved ? (_openBlock(), _createElementBlock("label", _hoisted_7, _toDisplayString(rate.description), 1)) : _createCommentVNode("", true)])], 8, _hoisted_4);
    }), 128))])]),
    _: 1
  }, 512), [[_vShow, $data.form.expenses.length]]), _createElementVNode("div", null, [_createVNode(_component_LlSecondaryButton, {
    disabled: !$options.canAddNewEmptyExpense,
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => $options.addNewEmptyExpense(), ["prevent"]))
  }, {
    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode(" Create Expense Template ", -1)]))]),
    _: 1
  }, 8, ["disabled"])]), _cache[10] || (_cache[10] = _createElementVNode("div", {
    class: "mt-5"
  }, [_createElementVNode("p", null, "Expense templates are shared with everyone in firm")], -1))])])) : _createCommentVNode("", true), _createVNode(_component_v_dialog, {
    modelValue: $data.openExpenseTemplate,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.openExpenseTemplate = $event),
    title: "Expense",
    width: "700"
  }, {
    default: _withCtx(() => [_createVNode(_component_expense_template_modal, {
      userService: _ctx.userService,
      codeService: $props.codeService,
      tracking: $props.tracking,
      alerts: $props.alerts,
      form: $data.form,
      onUpdatedExpenseTemplate: _cache[1] || (_cache[1] = $event => $options.updatedTemplate()),
      onCloseModal: _cache[2] || (_cache[2] = $event => $options.closeModal()),
      editingExpenseTemplate: $data.editingExpenseTemplate,
      editingTemplateId: $data.editingTemplateId,
      addExpenseTemplate: $data.addExpenseTemplate,
      editExpenseTemplate: $data.editExpenseTemplate,
      onDeleteExpenseTemplate: _cache[3] || (_cache[3] = $event => $options.deleteExpenseTemplate($data.editingTemplateId)),
      codes: $data.codes
    }, null, 8, ["userService", "codeService", "tracking", "alerts", "form", "editingExpenseTemplate", "editingTemplateId", "addExpenseTemplate", "editExpenseTemplate", "codes"])]),
    _: 1
  }, 8, ["modelValue"])], 64);
}